// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z6M9r","questions":"styles_questions__1KPYu","footer":"styles_footer__3G03O"};